import React from "react";

const Item = ({type, size}) => {

    let name = type

    let p0 = 0;
    let p1 = size;
    let p2 = p1 / 2;
    let p4 = p1 / 4;
    let p8 = p1 / 8;
    let p16 = p1 / 16;
    let p32 = p1 / 32;

    let svgitems = [];

    if (name === 'tk') {
        svgitems.push(<line key="l1" x1={p0} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke="#000000"
                            strokeLinecap="butt"/>);
    } else if (name === 'sw') {
        svgitems.push(<line key="k0" x1={p0} y1={p2 + p4} x2={p1} y2={p2 + p4} strokeWidth={p8} stroke="#000000"/>);
        svgitems.push(<line key="k3" x1={p2} y1={p0 + p4} x2={p1} y2={p2 + p4} strokeWidth={p8} stroke="#000000"
                            strokeLinecap="butt"/>);
    } else if (name === 'sg') {
        svgitems.push(<line key='s1'
                            x1={p2}
                            y1={p4 - p32}
                            x2={p2}
                            y2={p2 - p32}
                            stroke="#000000"
                            strokeWidth={p4}
                            strokeLinecap="round"/>);
        svgitems.push(<line key='s2'
                            x1={p2}
                            y1={p2}
                            x2={p2}
                            y2={p1}
                            stroke="#000000"
                            strokeWidth={p8}
                            strokeLinecap="round"/>);
    } else if (name === 'bk') {
        svgitems.push(<line key='s1'
                            x1={p0}
                            y1={p2}
                            x2={p1}
                            y2={p2}
                            stroke="#000000"
                            strokeWidth={p2}
                            strokeLinecap="round"/>);
        svgitems.push(<line key='s2'
                            x1={p0+p16}
                            y1={p2}
                            x2={p1-p16}
                            y2={p2}
                            stroke="#FFFFFF"
                            strokeWidth={p2-p8}
                            strokeLinecap="butt"/>);
    } else if (name === 'fb') {
        svgitems.push(<line key="l1" x1={p0} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke="#000000"
                            strokeLinecap="butt"/>);
        svgitems.push(<line key="l2" x1={p0+p4} y1={p2-p8} x2={p1-p4} y2={p2-p8} strokeWidth={p16} stroke="#000000"
                            strokeLinecap="butt"/>);
    }


    let svgx = <svg width={p1} height={p1}>
        {svgitems}
    </svg>;

    return (
        <div>
            {svgx}
        </div>
    )
}

export default Item;